module.exports = __webpack_public_path__ + "img/9630ab3e9a9c273dbbad625917a7f189-logo.png";